export const MESSAGE_KEY_PATTERN = /^productPage\./;

// Sections never sent through Velo/AI personalization — legal/compliance
// disclaimer text must not be rewritten, for any product.
export const EXCLUDED_PERSONALIZATION_SECTIONS = new Set(['footnotes']);
